import Vue from 'vue';

export default {
  namespaced: true,

  // initial state
  state: {
    authorized: localStorage.getItem('authorized') || false,
    error: '',
    auth_token: localStorage.getItem('auth_token') || '',
    user_id: localStorage.getItem('user_id') || '',
  },

  // getters
  getters: {
    //
  },

  // actions
  actions: {
    login({ commit }, params) {
      return new Promise((resolve, reject) => {
        let data = new FormData();

        data.set('auth_method', 0);
        data.set('mail', params.email);
        data.set('key', params.password);

        const config = { headers: { 'Content-Type': 'multipart/form-data' } };

        Vue.axios
          .post(`/login`, data, config)
          .then((response) => {
            if (response.status == 200 && response.data.status == 'ok') {
              localStorage.setItem('auth_token', response.data.auth_token);
              localStorage.setItem('user_id', response.data.user_id);
              Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.auth_token;
              Vue.axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
              Vue.axios.defaults.headers.delete['Content-Type'] = 'multipart/form-data';
              Vue.axios.defaults.headers.common['Content-Type'] = 'multipart/form-data';
              // Vue.axios.defaults.headers.common["Accept"] = "application/json";

              Vue.axios.interceptors.response.use(function (response) {
                  // Do something with response data
                  return response;
                }, function (error) {
                  return Promise.reject(error);
                });
              // Vue.axios.defaults.headers.delete['Content-Type'] = "application/json";

              // Vue.axios.defaults.headers.delete['Content-Type'] = 'multipart/form-data';

              commit('setAuthorized', true);
              commit('removeError');
              commit('setUserId', response.data.user_id);

              resolve(response);
            } else {
              commit('setError', 'Server error');
            }
          })
          .catch(() => {
            commit('setAuthorized', false);
            commit('setError', 'Invalid credentials');

            localStorage.removeItem('auth_token');

            reject('Invalid credentials');
          });
      });
    },
    changePassword({ commit }, params) {
      return new Promise((resolve) => {
        let data = new FormData();

        data.set('token', params.token);
        data.set('new_password', params.password);

        const config = {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${status.auth_token}`,
          },
        };

        Vue.axios
          .post(`/change_password/${params.token}`, data, config)
          .then((response) => {
              commit('removeError');
              resolve(response);
          })
          .catch(() => {
            commit('setError', 'Invalid token');
          });
      });
    },
    resetPassword({ commit }, params) {
      return new Promise((resolve, reject) => {
        let data = new FormData();

        data.set('mail', params.email);

        const config = {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        };

        Vue.axios
          .post(`/password_token`, data, config)
          .then((response) => {
              commit('removeError');
              resolve(response);
          })
          .catch((error) => {
            commit('setError', 'No user with this email');
            reject(error);
          });
      });
    },
    logout({ commit }) {
      commit('setAuthorized', false);
      commit('clearSettings');
    },
    unauthorize({ commit }) {
      commit('setAuthorized', false);
    },
  },

  // mutations
  mutations: {
    setError(state, error) {
      state.error = error;
    },
    removeError(state) {
      state.error = null;
    },
    setUserId(state, user_id) {
      state.user_id = user_id;
    },
    setAuthorized(state, status) {
      localStorage.setItem('authorized', status);
      if (status == false) {
        localStorage.removeItem('authorized');
      }
      state.authorized = status;
    },
    clearSettings() {
      localStorage.removeItem('settings');
    },
  },
};
